export const NOTI_ACTION_CREATE = 'create';
export const NOTI_ACTION_DELETE = 'delete';
export const NOTI_ACTION_UPDATE = 'update';
